<template>
  <div class="cart" style="min-height: 100vh">
    <div class="main">
      <div v-if="!uid || uid == 'null' || uid == ''" class="unlogin">
        <div class="unlogin-img"></div>
        <p>您还没有登录，请登录</p>
        <div class="goToLogin_btn" @click="toGoLogin">登录</div>
      </div>
      <div v-else>
        <div v-if="showPage">
          <div class="list order_list" v-if="orderList.length>0" v-infinite-scroll="loadMore"
               infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <ul>
              <li v-for="order in orderList">
                <div class="flexrow" style="height: 0.8rem; justify-content: space-between">
                  <div style="width: 80%" class="flexrow">
                    <div class="shopImg" :style="{backgroundImage:'url('+order.supplierUrl+')'}"></div>
                    <div class="shopName">
                      <span @click="toGoodsList(order.supplierId, order.supplier_name, order)"
                            class="arrow-right ellipse shop_name">{{ order.supplier_name }}</span>
                      <span class="time">{{ order.create_time }}</span>
                    </div>
                  </div>
                  <div style="width: 20%;text-align: right;color:#787878">
                    <div class="order-status">{{ order.orderStatusStr }}</div>
                    <div v-if="order.aboutOutDinnerDesc" style="font-size: .2rem; color: #FEC300;">
                      {{ order.aboutOutDinnerDesc }}
                    </div>
                  </div>
                </div>
                <div class="goods-list" @click="jumpToOrder(order.orderId, order.orderType)">
                  <div v-for="item in order.goodsList">
                    <span class="ellipse" style="display:inline-block;width: 80%;">{{ item.goodsName }}</span>
                    <span class="fr" style="color:#787878;">x {{ item.goodsNum }}</span>
                  </div>
                  <div class="moreList" v-if="order.omit">···</div>
                </div>
                <div style="width: 100% ;margin: 0.15rem 0 0.2rem 0;" class="clearflow"><span class="fr pr"><span
                  style="color: #787878">总计</span> <span style="font-weight: bold">￥{{ order.real_pay }}</span></span>
                </div>
                <div class="clearflow">
                  <span class="btn btn-order btn-yellow fr" v-if="order.canEstimated==1 && order.orderType != 4"
                        @click="toComment(order.orderId)">评价</span>
                  <span class="btn btn-order btn-plain fr"
                        v-if="(order.order_status==2002 || order.order_status==3001 || order.order_status==9000) && order.orderType != 4"
                        @click="moreOrder(order.orderId,order.supplierId, order.supplier_name)">再来一单</span>
                  <span class="btn btn-order btn-yellow fr" v-if="order.order_status==1000"
                        @click="jumpToOrder(order.orderId, order.orderType)">去支付</span>
                  <span class="btn btn-order btn-plain fr" v-if="order.order_status==1000 && order.orderType != 4"
                        @click="cancelOrder(order.orderId)" style="padding:0.08rem 0.2rem">取消订单</span>
                  <span class="btn btn-order btn-yellow fr"
                        v-if="order.orderPickUpInfoBean && order.orderPickUpInfoBean.takeStatus==0"
                        @click="openCabinet(order)">一键开柜取餐</span>
                  <span class="btn btn-order btn-yellow fr" v-if="order.reminderButton == 1"
                        @click="reminderOrder(order.orderId)">催单</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="no-info" v-else>
            <div class="no-goods">
              <img src="../assets/images/no-order.png"/>
              <p>还没有产生过订单</p>
            </div>
          </div>
          <!--加载下一页-->
          <div class="loading" style="margin-top: -.16rem" v-if="loading">
            <img src="../assets/images/loading.gif" alt="">
          </div>
        </div>
        <div class="no-info" v-if="noNetwork">
          <div class="no-goods">
            <img src="../assets/images/no-net.png"/>
            <p>连接不到网络...</p>
          </div>
        </div>
      </div>
    </div>
    <!--<footer class="fixed flex">-->
    <!--<router-link to="index"><span class="icon icon-home">首页</span></router-link>-->
    <!--<router-link to="orderlist"><span class="icon icon-order on">订单</span></router-link>-->
    <!--<router-link to="usercenter"><span class="icon icon-user">我的</span></router-link>-->
    <!--</footer>-->
    <!--开柜-->
    <div v-if="isShowCabinet" class="selfWrap">
      <div class="self-mask" style="width: 6.4rem;margin-left: -3.2rem;margin-top:-3rem;padding-top: 0">
        <div class="selfInfo1" style="padding: .7rem .4rem .5rem .4rem;margin-bottom: 0;background-color: transparent">
          <div class="fz-32">
            <img class="dingwei" src="../assets/images/icon-dingwei@2x.png"/>
            {{ chooseCabinetItem.orderPickUpInfoBean.deviceName }}
          </div>
          <div class="cell-no" style="width: 1.8rem">
            <div class="no" style="font-size: 1.2rem">
              {{ chooseCabinetItem.orderPickUpInfoBean.cellNo }}
            </div>
            <div class="fz-32" style="color: #797979">箱号</div>
          </div>
          <div style="margin: .4rem 0">请确保在自提柜附近操作开柜，防止餐品丢失。</div>
          <div class="btn-open" style="height:.84rem;line-height:.84rem;margin-bottom: .2rem" v-if="!isShowProgress"
               @click="sureCabinet">确认开柜
          </div>
          <div class="progressbar" v-if="isShowProgress">
            <div class="fill"></div>
          </div>
          <div class="btn-cancle" @click="cancelCab">取消开柜</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {actions} from '../store/actions'
import {InfiniteScroll} from 'mint-ui'
import _ from 'lodash';
//  import VConsole from 'vconsole/dist/vconsole.min.js'
//  let vConsole = new VConsole() // 初始化
Vue.use(InfiniteScroll)

export default {
  name: 'order',
  data() {
    return {
      showPage: false,
      orderList: [],
//        cacheOrderlist : [],
      hasMore: true,
      currentPage: 1,
      pageSize: 20,
      uid: null,
      loading: false,
      isOk: false,
      noNetwork: false,
      defaultGoodsList: [],
      anotherGoodsList: [],
      cartInfo: {},
      changeGoodsInCart: [],
      isShowCabinet: false,
      isShowProgress: false,
      chooseCabinetItem: {},
      clientHeight: document.documentElement.clientHeight,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.hasMore = false // 清除滚动加载
    if (to.name == 'TagPage') {
      to.meta.isUseCache = true
    }
    next()
  },
  mounted() {
    if (!this.$utils.isWeiXin()) {
      window.onpopstate = () => {
        // alert('1')
        history.go(1)
      }
    }
    //页面返回刷新
    window.addEventListener('pageshow', function (e) {
      console.log('pageshow')
      if (e.persisted) {
        window.location.reload()
      }
    })
  },
  activated: function () {
    // document.title = '我的订单';
    this.uid = this.$store.state.wxUid
    // 来源：上海现代高校智慧后勤研究院
    // localStorage.removeItem('urlSource');
    // let url = this.$utils.resolveUrl();
    // if (url.source && url.source == 'yjy') {
    //   localStorage.setItem('urlSource','yjy');
    //   // this.$route.meta.showTab = false;
    //   document.getElementsByTagName("footer")[0].style.display = 'none';
    // }
    // if (url.school_id) {
    //   this.getSchoolStatus(url.school_id);
    // }

    this.hasMore = true
    if (this.uid && this.uid !== "null" && this.uid !== '') {
      if (!this.$route.meta.isUseCache) {
        this.currentPage = 1;
        this.orderList = []
        this.$indicator.open()
        this.getOrderList(true)
      }
    }
  },
  methods: {
    getOrderList: function (flag) {
      var _this = this
      this.isOk = false;
      if (!this.hasMore) {
        return;
      }
      if (flag) {
        this.showPage = false
        this.orderList = []
        this.currentPage = 1
      }
      var params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      actions.postOrderList(_this, params, (data) => {
        this.$indicator.close();
        if (data != null && data.list.length > 0) {
          if (data.list.length < this.pageSize) {
            this.hasMore = false
          }
          this.currentPage++;

          var orderList = this.orderList.concat(data.list)
          this.orderList = orderList
          for (var i = 0; i < this.orderList.length; i++) {
            if (this.orderList[i].goodsList && this.orderList[i].goodsList.length > 3) {
              this.orderList[i].goodsList = this.orderList[i].goodsList.slice(0, 3);
              this.orderList[i].omit = true;
            } else {
              this.orderList[i].omit = false;
            }
          }
          this.isOk = true
        } else {
          this.hasMore = false
        }
        this.showPage = true
        this.noNetwork = false
        this.$nextTick(() => {
          let goodsList = document.getElementsByClassName('order_list');
          let uid = localStorage.getItem('wxUid');
          if (uid && goodsList && goodsList[0] && this.orderList && this.orderList.length > 0) {
            let item = goodsList[0].clientHeight / this.orderList.length;
            let size = Math.round(this.clientHeight / item);
            this.$store.commit('changeRecordItemHeight', item);
            this.$store.commit('changeRecordList', this.orderList);
            this.$store.commit('changeRecordOtherHeight', 0);
            this.$store.commit('changeRecordPage', 'OrderList');
            this.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, this.orderList, 'asa_oc_order_list', 'supplierId')
          }
        })
      }, () => {
        this.$indicator.close();
        this.noNetwork = true;
      })
    },
    loadMore: function () {
      if (!this.hasMore) {
        return;
      }
      if (this.isOk) {
        this.loading = true;
//          this.$indicator.open()
        setTimeout(() => {
          this.getOrderList(false)
          this.loading = false;
        }, 1000);
      }

    },
    // 取消订单
    cancelOrder: function (id) {
      this.$messagebox.confirm('确定取消订单吗?', '').then(action => {
        var _this = this
        var params = {
          order_id: id
        }
        actions.postCancelOrder(_this, params, function (data) {
          _this.$toast('取消成功')
          _this.hasMore = true // 重置
          _this.getOrderList(true)
        })
      }).catch(() => {

      })
    },
    // 催单
    reminderOrder: function (id) {
      var _this = this
      var params = {
        order_id: id
      }
      actions.reminderOrder(_this, params, function (data) {
        _this.$toast(data.msg)
        // _this.getOrderList(true)
      })
    },
    jumpToOrder: function (id, type) {
      var _this = this;
      window.localStorage.setItem('orderCode', id);
      if (type == 4) {
        _this.$router.push({name: 'RestaurantDetail'})
      } else {
        _this.$router.push({name: 'OrderDetail'})
      }
    },
    toGoodsList: function (id, name, item) {
      if (item.orderType != 4) {
        var _this = this;
        var obj = {
          shop_code: id,
          shop_name: name,
          showBlockType: 'orderDishes',
        };
        _this.$store.commit('changeState', obj);
        _this.$router.push({name: 'GoodsList'});
      }
    },
    toComment: function (id) {
      var _this = this;
      var obj = {
        orderCode: id
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({name: 'OnlineComment'})
    },
    toGoLogin: function () {
      this.$utils.toLogin(this);
    },
    moreOrder: function (id, code, name) {
      var _this = this
      var obj = {
        shop_code: code,
        shop_name: name,
        showBlockType: 'orderDishes'
      }
      _this.$store.commit('changeState', obj)
      _this.anotherGoodsList = []
      _this.defaultGoodsList = []
      _this.changeGoodsInCart = []
      _this.shopDetail = {}

      // 获取店铺商品列表
      actions.getGoodsList(_this, {shop_id: code}, function (data) {
        _this.shopDetail = data.shop_detail;//店铺信息
        if(!_this.shopDetail.req_type){
          data.item_list.forEach((item) => {
            if(item.goods_list && item.goods_list.length){
              item.goods_list = item.goods_list.map((secItem) => ({
                ...secItem,
                is_special_tag: item.is_special_tag,
                cateType: item.type
              }));
              _this.defaultGoodsList = _this.defaultGoodsList.concat(item.goods_list) // 商品总数据
            }
          });
        }
        // 获取再来一单商品
        actions.getOrderDetail(_this, {order_id: id}, function (data1) {
          _this.anotherGoodsList = data1.goods_list // 再来一单商品
          if(_this.shopDetail.req_type){
            if(_this.anotherGoodsList && _this.anotherGoodsList.length){
              var codesList = []
              _this.anotherGoodsList.forEach(item=>{
                codesList.push(item.gdCode+'')
              })
              var params = {
                codes: codesList,
                shopCode: code,
                specialTag: 0,
                token: _this.$store.state.wxToken
              };
              actions.getShopDetailList(_this, params, function (val) {
                _this.$indicator.close();
                var params1 = {
                  shop_id: code,
                  token: _this.$store.state.wxToken
                };
                actions.getGoodsList(_this, params1, function (val1) {
                  var list = val1.item_list
                  for(let k of list){
                      val.goods_list.forEach(secItem => {
                        if(secItem.tag_id == k.tag_id){
                          secItem.is_special_tag = k.is_special_tag
                          secItem.cateType = k.type
                        }
                      })
                  }
                  _this.defaultGoodsList = val.goods_list // 商品总数据
                  _this.ToGoodsList(code,data.amount,data.real_pay,id)
                })

              })
            }
          }else{
            _this.ToGoodsList(code,data.amount,data.real_pay,id)
          }
        })
      }, function () {
      })

    },
    ToGoodsList(code,amount,real_pay,id){
      var _this = this
      let marketObj = {}
      let totalAmount = 0
      _this.defaultGoodsList.filter((item) => item.is_special_tag === 0).forEach(firItem => {
        // 下架商品
        _this.anotherGoodsList.forEach(secItem => {
          if (secItem.isGift != 2) {
            let goodsInfo = {};
            let goodsId = secItem.skuCode;
            let specAttrStr = secItem.specification || '';
            if (firItem.gd_code === secItem.gdCode) {
              let attrIdArr = [];
              let attributes = [];
              // 判断商品名称改变
              if (secItem.name != firItem.goods_name) {
                let specificationName = secItem.specification || ''
                _this.changeGoodsInCart.push({id: secItem.skuCode, name: secItem.name + specificationName, num: 0})
                return
              }
              // 判断属性名称改变
              let attrsPrice = 0;
              if (secItem.attribute) {
                const totalAttr = _.flattenDeep(
                  firItem.attribute_list.map((item) => {
                    return item.attributeList.map((secItem) => ({
                      ...secItem,
                      attributeTypeId: item.attributeTypeId,
                      attributeTypeName: item.attributeTypeName
                    }))
                  })
                )
                let totalAttr1 = totalAttr.filter((item) => !item.skuCode || item.saleStatus == 1);
                const currentAttr = secItem.attribute.split('/');
                const isChange = !currentAttr.every((item) => _.find(totalAttr1, {name: item}));
                if (isChange) {
                  return _this.changeGoodsInCart.push({
                    id: secItem.skuCode,
                    name: secItem.name + (secItem.specification ? ('-' + secItem.specification) : '-') + secItem.attribute,
                    num: 0
                  });
                }
                attrIdArr = _.flattenDeep(
                  currentAttr.map((item) => {
                    const findObj = _.find(totalAttr, {name: item}) || {};
                    return [findObj.attributeTypeId, findObj.id]
                  })
                );
                attributes = currentAttr.map((item) => {
                  const findObj = _.find(totalAttr, {name: item}) || {};
                  if (findObj.salePrice) {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name,
                        salePrice: findObj.salePrice,
                        skuCode: findObj.skuCode
                      }]
                    }
                  } else {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name
                      }]
                    }
                  }
                });
                // 存在加价属性
                if (secItem.attributeSkuList && secItem.attributeSkuList.length > 0) {
                  let idArray = [];
                  let newAarray = [];
                  attributes.forEach(function (ele, i) {
                    if (idArray.indexOf(attributes[i].id) === -1) {
                      newAarray.push(attributes[i])
                      idArray.push(attributes[i].id);
                    } else {
                      newAarray.forEach(function (dom, k) {
                        if (newAarray[k].id == attributes[i].id) {
                          newAarray[k].attributeList.push(attributes[i].attributeList[0]);
                        }
                      })
                    }
                  })
                  attributes = newAarray;
                  for (let v of secItem.attributeSkuList) {
                    for (let v1 of totalAttr) {
                      if (v1.skuCode == v.skuCode) {
                        attrsPrice = (parseFloat(attrsPrice) + parseFloat(v1.salePrice)).toFixed(2);
                      }
                    }
                  }

                }
                if (specAttrStr.length > 0) {
                  specAttrStr += '/' + secItem.attribute
                } else {
                  specAttrStr = secItem.attribute
                }
              }
              let findSku = {};
              for (let obj of firItem.sku_list) {
                if (obj.sku_id == goodsId) {
                  findSku = {...obj};
                  // 整理购物车数据
                  let singleTotalPrice = 0
                  let singleOriginPrice = 0 // 单个商品现总价和原总价
                  let noStock = false
                  // let findSku = _.find(firItem.sku_list, {sku_id: goodsId});

                  if (secItem.specification && secItem.specification.length > 0) {
                    // 判断规格名称改变
                    let specification = secItem.specification.substring(0, secItem.specification.indexOf('/')) || secItem.specification
                    // let specFlag = 0
                    // firItem.sku_list.forEach(thirdItem => {
                    //   if (thirdItem.sku_id == secItem.skuCode && thirdItem.specification === specification) {
                    //     specFlag++
                    //   }
                    // })
                    if (findSku.specification != specification) {
                      _this.changeGoodsInCart.push({
                        id: secItem.skuCode,
                        name: secItem.name + secItem.specification,
                        num: 0
                      })
                      return
                    }
                  }

                  // 判断库存
                  if (findSku.stock === 0) {
                    let specificationName = secItem.specification || ''
                    _this.changeGoodsInCart.push({
                      id: secItem.skuCode,
                      name: secItem.name + specificationName,
                      num: 0
                    })
                    return
                  }
                  if (findSku.stock < secItem.buyNum) {
                    noStock = true // 无库存
                    let specificationName = secItem.specification || ''
                    _this.changeGoodsInCart.push({
                      id: secItem.skuCode,
                      name: secItem.name + specificationName,
                      num: findSku.stock
                    })
                    totalAmount += findSku.stock
                  } else {
                    noStock = false // 有库存
                    totalAmount += secItem.buyNum
                  }
                  // 计算活动价格
                  if (attrsPrice > 0) {
                    findSku.activity_price = (parseFloat(findSku.activity_price) + parseFloat(attrsPrice)).toFixed(2);
                    findSku.sales_price = (parseFloat(findSku.sales_price) + parseFloat(attrsPrice)).toFixed(2);
                  }
                  if (findSku.num_per_goods > 0) { // 是活动商品
                    singleTotalPrice = (findSku.activity_price * findSku.num_per_goods + findSku.sales_price * (secItem.buyNum - findSku.num_per_goods)).toFixed(2)
                  } else { // 无活动商品
                    singleTotalPrice = (findSku.sales_price * secItem.buyNum).toFixed(2)
                  }
                  singleOriginPrice = (findSku.sales_price * secItem.buyNum).toFixed(2) // 单个折扣商品的总原价
                  goodsInfo = {
                    activeBuyNum: findSku.num_per_goods, // 活动商品限购数量
                    activePrice: findSku.activity_price,
                    activityId: findSku.activity_id,
                    cartNum: noStock ? findSku.stock : secItem.buyNum,
                    cateType: firItem.cateType, // 商品是否限购
                    gdName: secItem.name,
                    is_single_spec: firItem.is_single_spec, // 是否为单规格
                    noStock: noStock,
                    original_tag_id: firItem.tag_id,
                    restriction_num: firItem.restriction_num, // 限购数量
                    restriction_type: firItem.restriction_type, // 限购类型 0-不限购；1-每单限购
                    salePrice: findSku.sales_price,
                    singleOriginPrice: singleOriginPrice,
                    singleTotalPrice: singleTotalPrice,
                    sku_id: secItem.skuCode,
                    sku_list: firItem.sku_list,
                    specification: {id: findSku.specification_id, name: findSku.specification}, // 规格
                    specifications: findSku,
                    stock: findSku.stock,
                    tag_id1: firItem.tag_id,
                    goodsNum: findSku.num_per_goods,
                    orderNum: findSku.num_per_order,
                    leftNum: findSku.left_stock,
                    specAttrStr: specAttrStr,
                    attributes: attributes,
                    attrIdArr: _.uniq(attrIdArr),
                    packing_fee: firItem.packing_fee,
                    packing_fee_rule: firItem.packing_fee_rule,
                    gd_code: firItem.gd_code,
                  };
                  marketObj[goodsId] = [
                    ..._.get(marketObj, goodsId, []),
                    goodsInfo
                  ];
                }
              }
            }
          }
        })
        _this.cartInfo[code] = {
          total: totalAmount,
          amount: amount,
          market: marketObj,
          originAmount: real_pay
        }
      })
      window.localStorage.setItem('changeGoodsInCart', JSON.stringify(_.uniqWith(_this.changeGoodsInCart, _.isEqual)))
      _this.$store.commit('changeCartInfo', _this.cartInfo) // 更新购物车总价信息
      _this.$router.push({name: 'GoodsList', params: {orderCode: id}})
    },
    openCabinet: function (order) {
      this.isShowCabinet = true;
      this.chooseCabinetItem = order;
    },
    cancelCab() {
      this.isShowCabinet = false;
      this.isShowProgress = false;
    },
    sureCabinet() {
      var _this = this
      let params = {
        operateType: 0,
        order_id: _this.chooseCabinetItem.orderId
      }
      // _this.$indicator.open({text: '开柜中'})
      _this.isShowProgress = true;
      actions.openCabinet(_this, params, function (data) {
        _this.isShowCabinet = false;
        _this.isShowProgress = false;
        _this.$router.push({path: `/deviceDetail/${_this.chooseCabinetItem.orderId}`})
      }, function (data) {
        _this.isShowProgress = false;
        _this.$toast(data.data.message);
      })
    },
    // 获取学校状态
    getSchoolStatus(schoolId) {
      var _this = this;
      actions.postSchoolStatus(_this, {school_id: schoolId}, function (data) {
        let schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        }
        _this.$store.commit('changeSchoolInfo', schoolInfo)
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '')
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// OrderList.vue?afc6509c